import React, { FC } from 'react'
import { useNavigate } from 'react-router'
import { useLeadFilter } from '../slice/leadSlice'

const TABS = [
 { label: 'All Leads', key: 'all-leads' },
 { label: 'My Leads', key: 'my-leads' },
] as const

const LeadListTitleTabsBlock: FC<{ selectedKey: 'all-leads' | 'my-leads' }> = ({
 selectedKey,
}) => {
 const { handleUpdateTab } = useLeadFilter()
 const navigate = useNavigate()

 return (
  <div className="lead-tabs-block">
   {TABS.map(({ label, key }) => (
    <button
     key={key}
     type="button"
     className={`lead-tab-btn${selectedKey === key ? ' active' : ''}`}
     onClick={() => {
      navigate(`/admin/leads/${key}`)
      handleUpdateTab('totallead')
     }}
    >
     {label}
    </button>
   ))}
  </div>
 )
}

export default LeadListTitleTabsBlock
